import { Box, Typography } from "@mui/material";

type HeatStatus = {
  name: string;
  color: string;
  letter: string;
};

const heatStatuses: { [key: string]: HeatStatus } = {
  Scheduled: { name: "Scheduled", color: "#0288D1", letter: "S" },
  Melting: { name: "Melting", color: "#FF7043", letter: "M" },
  Tapped: { name: "Tapped", color: "#FFD600", letter: "T" },
  Arrive: { name: "In LMF", color: "#00610E", letter: "L" },
  ReadyToCast: { name: "Ready To Cast", color: "#FFC107", letter: "U" },
  InCaster: { name: "In Caster", color: "#FF5722", letter: "C" },
  Opened: { name: "Opened", color: "#43A047", letter: "O" },
  Closed: { name: "Closed", color: "#607D8B", letter: "P" },
  Finished: { name: "Finished", color: "#3F51B5", letter: "F" },
};

type HeatStatusTagProps = {
  letter: string;
  showText?: boolean;
};

export const HeatStatusTag = ({
  letter,
  showText = true,
}: HeatStatusTagProps) => {
  const value = Object.values(heatStatuses).find(
    (status) => status.letter === letter,
  );

  if (!value) {
    return null;
  }

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: "4px" }}>
      <Box
        title={value.name}
        sx={{
          width: "26px",
          height: "26px",
          borderRadius: "4px",
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#fff",
          fontWeight: "bold",
          backgroundColor: value.color,
        }}
      >
        {value.letter}
      </Box>
      {showText && value.name && (
        <Typography component="span">{value.name}</Typography>
      )}
    </Box>
  );
};
